import { useHistory } from 'react-router-dom';
import { shouldRenderDirectBookInDrawer } from 'Common/config';

/**
 * Returns the time slot and "view more" click handlers for the provider list.
 * When direct book renders in a drawer, slots render as buttons rather than
 * links, so these handlers open the direct book drawer route. The current
 * location is passed as route state so the map stays rendered behind it.
 */
export default function useDirectBookDrawerNavigation({
  config,
  location,
  providers
}) {
  const history = useHistory();

  const openDirectBookDrawer = (providerId, url) => {
    const provider = providers.find((p) => p.id === providerId);
    if (shouldRenderDirectBookInDrawer(config) && provider && url) {
      history.push(url, {
        provider: {
          location,
          provider
        }
      });
    }
  };

  const onTimeSlotsClick = (_, { providerId, href }) => {
    openDirectBookDrawer(providerId, href);
  };

  const onViewMoreClick = (_, { providerId, viewMoreBookOnlineUrl }) => {
    openDirectBookDrawer(providerId, viewMoreBookOnlineUrl);
  };

  return { onTimeSlotsClick, onViewMoreClick };
}
